import React, {useEffect, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, isTablet} from "../../components/Utils";
import {PROTECTION_CHIMIQUE, SECURITE_BIEN_ETRE_CODE, URL_FOR_RESOURCES} from "../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {Taxon} from "../Entity/Taxon";
import {handleCheckedFilters, hasSubTaxons} from "../../components/UtilsForCart";
import {Link} from "react-router-dom";
import {Filter} from "../Entity/Filter";
import {getBrandBySlug} from "../Brand/BrandSlice";

interface ComponentProps {
  setGroupCode: React.Dispatch<React.SetStateAction<string>>,
  setTaxonomiesSelected: React.Dispatch<React.SetStateAction<string[]>>,
  setFiltersSelectedParent: React.Dispatch<React.SetStateAction<string>>,
  filtersSelectedParent: string,
  taxonomiesSelected: string[],
  setGroupCodeParent: React.Dispatch<React.SetStateAction<string>>,
  handleShowAndGetSubTaxons: any,
  chekIfSubTaxonsParentIsDifferent: any,
  subTaxonsParent: Filter | undefined,
  arraySubTaxonsCounter: {parentCode: string; taxonsCodes: string[]; count: number;}[],
  setArraySubTaxonsCounter: React.Dispatch<React.SetStateAction<{parentCode: string; taxonsCodes: string[]; count: number;}[]>>
  showEPISubTaxonomies: boolean,
  isEndOfStock: boolean
}

const TaxonomiesProducts: React.FC<ComponentProps> = ({setGroupCode,
                                                        setTaxonomiesSelected,
                                                        setFiltersSelectedParent,
                                                        filtersSelectedParent,
                                                        taxonomiesSelected,
                                                        setGroupCodeParent,
                                                        handleShowAndGetSubTaxons,
                                                        chekIfSubTaxonsParentIsDifferent,
                                                        subTaxonsParent,
                                                        arraySubTaxonsCounter,
                                                        setArraySubTaxonsCounter,
                                                        showEPISubTaxonomies,
                                                        isEndOfStock
                                                      }:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const taxonsSecurity = useSelector((s: RootState) => s.taxonRdc.taxons);
  const productTaxons = useSelector((state:RootState) => state.filtersRdc.filters);
  const isRequestingTaxons = useSelector((state: RootState) => state.filtersRdc.isRequesting);
  const taxonomyParent = SECURITE_BIEN_ETRE_CODE;

  const taxonomiesProducts = productTaxons && productTaxons.filter((a) => a.parentCode === filtersSelectedParent);

  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const brandDetail = useSelector((state:RootState) => state.brandRdc.brand)
  const currentBrand = brandDetail !== undefined ? brandDetail : null

  const filters = useSelector((state:RootState) => state.filtersRdc.filters);
  const dispatch = useDispatch();
  const [showPrevorBrand, setShowPrevorBrand] = useState(false)

  const [cachedParents, setCachedParents] = useState<Taxon[]>([]);

  useEffect(() => {
    const parents = (taxonsSecurity ?? []).filter(a => a.parentCode === taxonomyParent);
    if (parents.length) setCachedParents(parents); // ne remplace que si on a des données
  }, [taxonsSecurity, taxonomyParent]);

  const parentsToRender = React.useMemo(() => {
    const fromStore = (taxonsSecurity ?? []).filter(a => a.parentCode === taxonomyParent);
    return fromStore.length ? fromStore : cachedParents;
  }, [taxonsSecurity, taxonomyParent, cachedParents]);


  useEffect(() => {
    changeLanguage(locale);
    if(filtersSelectedParent == PROTECTION_CHIMIQUE){
      dispatch(getBrandBySlug(locale,"prevor"))
      setShowPrevorBrand(true)
    }else{
      setShowPrevorBrand(false)
    }
  }, [filtersSelectedParent]);

  return (
    <header className="align-items-center">
      <header className="show-categories py-3">
        {
          filtersSelectedParent !== "" && !isEndOfStock ?
            <div className="row w-100 justify-content-between align-items-start row-taxonomies">
              <div className="col-lg-3">
                <div className={isOpenMenu ? "categories-btn opened" : "categories-btn"}>
                  <button type="button" className="show-dropdown btn btn-dark width100" onClick={() => setIsOpenMenu(!isOpenMenu)}>
                    <i className="fas fa-bars px-2"/> { t('view_categories')}
                  </button>
                  <div className={isTablet && isOpenMenu ? "tt-dropdown-menu tt-dropdown-menu-mobile open" : isTablet ? "tt-dropdown-menu  tt-dropdown-menu-mobile" : "tt-dropdown-menu"}>
                    <nav>
                      {
                        isTablet ?
                          <div className="col-md-12 d-flex justify-content-end mt-2 mb-2" onClick={() => setIsOpenMenu(!isOpenMenu)}>
                            <i className="fa-solid fa-times fontsize25 mr-2"></i>
                          </div>
                          : null
                      }
                      <ul className={isTablet ? "row" : ""}>
                        {
                          //dropdown menu catégories parentes
                          parentsToRender.map((taxonItem: Taxon) => (
                              <li className={isTablet ? "tt-submenu col-md-4 col-sm-6 card noborder parents-taxon-mobile" : "tt-submenu"} key={taxonItem.code}>
                                {
                                  taxonItem.redirectUrl ?
                                    <Link to={taxonItem.redirectUrl} className={isTablet ? "border" : ""}>
                                      <img width="40" height="40" src={ URL_FOR_RESOURCES + taxonItem.icon } alt={taxonItem.name}/>{ taxonItem.name }
                                    </Link>
                                    :
                                    <Link
                                      to={`/${locale}/${t('url_catalogue')}?${taxonItem.parentCode}=${taxonItem.code}`}
                                      className={isTablet ? "border" : ""}
                                      onClick={() => setIsOpenMenu(false)}
                                    >
                                      <img width="40" height="40" src={URL_FOR_RESOURCES + taxonItem.icon} alt={taxonItem.name} />
                                      {taxonItem.name}
                                    </Link>

                                }
                              </li>
                            ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                {
                  showPrevorBrand && currentBrand ?
                    <div className="row mb-0">
                      <header className="border-top py-3 pb-0 d-flex align-items-center py-2 container-brand-info">
                          {
                            currentBrand.logo && <img src={URL_FOR_RESOURCES + "/" + currentBrand.logo} className="height-40 m-h-40 mr-2 border rounded" alt={`${currentBrand.name}-logo`}/>
                          }
                          <h5>{currentBrand.name}</h5>
                          {
                            currentBrand.description && <p className="mb-0" dangerouslySetInnerHTML={{ __html: currentBrand.description }} />
                          }
                      </header>
                    </div>
                    : null
                }
                <ul className="subcategories d-flex align-content-start mb-0 pb-0 flex-wrap">
                  {
                    isRequestingTaxons ?
                      <SpinnerOnTop/>
                      :

                      !showEPISubTaxonomies ?
                      taxonomiesProducts && taxonomiesProducts.map((taxonItem: Filter) => {
                    const count = arraySubTaxonsCounter.find(item => item.parentCode === taxonItem.code)?.count || 0;
                    return(
                    <li key={taxonItem.label}>
                  {
                    hasSubTaxons(taxonItem, filters).length > 0 ?
                      <button
                        type="button"
                        className={subTaxonsParent && subTaxonsParent.code === taxonItem.code ? "btn btn-light text-primary" : "btn btn-light"}
                        onClick={() => {
                          handleShowAndGetSubTaxons(taxonItem.code);
                          if (subTaxonsParent && subTaxonsParent.code === taxonItem.code) {
                            chekIfSubTaxonsParentIsDifferent("");
                          } else {
                            chekIfSubTaxonsParentIsDifferent({...taxonItem});
                          }
                        }}
                      >
                        {taxonItem.label}
                        {subTaxonsParent && subTaxonsParent.code === taxonItem.code
                          ? <i className="fa-solid fa-chevron-up fontsize12"/>
                          : <i className="fa-solid fa-chevron-down fontsize12"/>
                        }
                        {count > 0 ? <span className="number-subtaxons-selected">{count}</span> : null}
                      </button>
                      :
                      <label className="checkbox-btn mr-0">
                        <input
                          type="checkbox"
                          checked={taxonomiesSelected.includes(taxonItem.code)}
                          onChange={() => {
                            // ✅ 1) groupCode DOIT rester le parentCode de la taxonomie (ex: "securite-bien-etre")
                            setGroupCode(taxonItem.parentCode ?? "");

                            // ✅ 2) values = codes des taxons sélectionnés
                            setTaxonomiesSelected(prev => {
                              const exists = prev.includes(taxonItem.code);
                              return exists ? prev.filter(code => code !== taxonItem.code) : [...prev, taxonItem.code];
                            });

                            // ✅ 3) (optionnel) si tu veux suivre le parent sélectionné
                            setFiltersSelectedParent(taxonItem.parentCode ?? "");
                          }}
                        />
                        <span className="btn btn-light">{taxonItem.label}</span>
                      </label>
                  }
                    </li>
                    )
                        })

                        : null
                  }
                </ul>
              </div>
            </div>
            : null
        }
      </header>
    </header>
  )
}
export default TaxonomiesProducts;
